import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './style.scss';
import { operatingSystems } from './data/operatingSystems';
import DownloadCard from './DownloadCard';
import SystemRequirements from './SystemRequirements';
import { useVersion, VersionProvider } from './VersionProvider';

const animations = {
  container: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  },
  item: {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  },
};

const Download = () => {
  const [selectedOS, setSelectedOS] = useState(null);
  const { version } = useVersion();
  console.log('Version:', version);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes('mac')) {
      setSelectedOS('macOS');
    } else if (userAgent.includes('win')) {
      setSelectedOS('Windows');
    } else if (userAgent.includes('linux')) {
      setSelectedOS('Linux');
    }
  }, []);

  return (
    <div className="download-page position-relative">
      <motion.div
        className="container py-5"
        initial="hidden"
        animate="visible"
        variants={animations.container}
        style={{ zIndex: 2, position: 'relative' }}
      >
        <motion.div className="text-center mb-5" variants={animations.item}>
          <h1 className="display-4 fw-bold mb-4 text-primary pt-5">
            Get Started with
            <br />
            <span className="text-gradient">Quartermaster</span>
          </h1>
          <p className="lead mb-4">
            Download the latest version of Quartermaster for your operating
            system and start building powerful AI agents today. Choose your
            platform below and follow the installation guide.
          </p>
        </motion.div>

        <div className="row g-4 mb-5">
          {operatingSystems.map((os) => (
            <motion.div
              key={os.name}
              className="col-md-4"
              variants={animations.item}
            >
              <DownloadCard os={os} isActive={selectedOS === os.name} />
            </motion.div>
          ))}
        </div>

        <motion.div
          className="py-5"
          initial="hidden"
          animate="visible"
          variants={animations.container}
        >
          <SystemRequirements />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default () => (
  <VersionProvider>
    <Download />
  </VersionProvider>
);